var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container text-center"},[_c('small',[_vm._v(" Ulrich Goldmann / 2020 / disclaimer ")])])])}]

export { render, staticRenderFns }